module.exports = __webpack_public_path__ + "img/pic11.8c8017d6.png";